import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[wzExpandablePanel]',
  standalone: false,
})
export class ExpandablePanelDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.initElement();
  }

  public toggle(isExpanded: boolean = false) {
    if (!isExpanded) {
      this.renderer.setStyle(this.el.nativeElement, 'max-height', '0px');
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'max-height', '300px');
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
    }
  }

  private initElement() {
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
    this.renderer.setStyle(this.el.nativeElement, 'transition', 'all 0.3s');
  }
}
